import * as Yup from "yup";
import { newIntegrationType, integrationType } from "../Gateways/constants";
import MaliciousIpContainer from "../MaliciousIp/components";
import BtagStatistics from "./components/btagMapping";
import { ReactComponent as OrderIcon } from "../../images/icons/section-icons/order.svg";
import { ReactComponent as OrderIconActive } from "../../images/icons/section-icons/order-active.svg";
import { maliciousIpsAccess } from "../MaliciousIp/constants";

export const BRAND_SERVICE_LIST = "brand_service_list";
export const SERVICES_URL = "integrations/brand/:brandId/integration/services";
export const BTAG_STATS_URL = "integrations/brand/:brandId/btag-stats";

export const BTAG_STATS = "btag-stats";

export type serviceListType = {
  [key: string]: integrationType;
};

export type btagMappingType = {
  party_id: string;
  passcode: string;
  btag: string;
  created_at: string;
};

export type serviceType = integrationType | newIntegrationType;

export type serviceDataType = integrationType & {
  visible?: boolean;
  options?: string[];
};

export type servicesType = serviceType[];

export type serviceGatewayType = {
  active: boolean;
  id: number;
  phone_code?: string[];
  position?: number;
};

export type availableServiceGatewayType = serviceGatewayType & {
  name: string;
};

export const SERVICES = {
  AING: {
    alias: "aing",
    name: "Whizdom AI",
    type: "service",
  },
  CAPTCHA: {
    alias: "captcha",
    name: "Captcha",
    type: "service",
  },
  PHONE_VERIFICATION: {
    alias: "phoneVerification",
    name: "Phone verification",
    type: "service",
  },
  TWO_FACTOR_AUTHENTICATION: {
    alias: "twoFactorAuthentication",
    name: "2FA Service",
    type: "service",
  },
  ZING: {
    alias: "zing",
    name: "Zing AI",
    type: "service",
  },
  BLACKBOX: {
    alias: "blackbox",
    name: "AntiFraud",
    type: "service",
  },
  NOTIFICATION_KYC: {
    alias: "notificationEmailKyc",
    name: "KYC Notification",
    type: "service",
  },
  PASSKEYS: {
    alias: "passkeys",
    type: "service",
    name: "GTAuth",
  },
  SCAMMER: {
    alias: "scammer",
    type: "service",
    name: "Scammer",
  },
  SCAMMER_COOKIE: {
    alias: "scammerCookie",
    type: "service",
    name: "Scammer Cookie",
  },
  SCAMMER_DYNAMIC: {
    alias: "scammerDynamic",
    type: "service",
    name: "Dynamic Scammer Service",
  },
  IP_BLOCKER: {
    alias: "ip_blocker",
    type: "service",
    name: "IP Blocker",
  },
  CHAT_SUPPORT: {
    alias: "chatSupport",
    type: "service",
    name: "Chat Support",
  },
  KYC_SERVICE: {
    alias: "kyc",
    type: "service",
    name: "KYC Service",
  },
  ZERO_BOUNCE: {
    alias: "zeroBounce",
    type: "service",
    name: "ZeroBounce",
  },
  BTAG_MAPPING: {
    alias: "btag",
    type: "service",
    name: "Btag Mapping",
  },
  AUTH_SETTINGS_SERVICE: {
    alias: "authSettings",
    type: "service",
    name: "Registration Services",
  },
  GAME_PROXY: {
    alias: "gameProxy",
    type: "service",
    name: "Game Proxy",
  },
  CEKYATIR: {
    alias: "redeposit",
    type: "service",
    name: "Cek-Yatir",
  },
  DEPOSIT_PREDICTION: {
    alias: "predictedDeposit",
    type: "service",
    name: "Predicted Deposit",
  },
  TRUEPLAY: {
    alias: "trueplay",
    type: "service",
    name: "Trueplay",
  },
  BLIK_ONE_CLICK: {
    alias: "blikOneClick",
    type: "service",
    name: "Blik One-Click",
  },
  RESTRICTION: {
    alias: "restriction",
    type: "service",
    name: "Functionality Restriction",
  },
  LICENCE: {
    alias: "licence",
    type: "service",
    name: "Licence",
  },
  APPSFLYER: {
    alias: "appsflyer",
    type: "service",
    name: "Appsflyer",
  },
  POSTVIEW: {
    alias: "adwise",
    type: "service",
    name: "Postview",
  },
};

export const SETTINGS_TYPE = {
  SMS: "sms",
  EMAIL: "email",
  GOOGLE: "google",
  TRUSONA: "trusona",
  MESSENGER: "messenger",
};

export const IP_BLOCKER_TYPE = {
  LOGIN: "login",
  SIGN_UP: "sign_up",
};

export const CAPTCHA_TYPE = {
  V2: "reCaptchaV2",
  V3: "reCaptchaV3",
};

export const smsContentFieldsConfig = {
  textEditor: {
    fieldName: "settings.sms.template",
    label: "Content",
    infoBoxMsg: `{CODE} - one time password\n{USERNAME} - username`,
  },
};

export const messengerContentFieldsConfig = {
  textEditor: {
    fieldName: "settings.messenger.template",
    label: "Content",
    infoBoxMsg: `{CODE} - one time password\n{USERNAME} - username`,
  },
};

export const phoneVerificationContentFieldsConfig = {
  textEditor: {
    fieldName: "settings.sms.template",
    label: "Content",
    infoBoxMsg: `{CODE} - one time password`,
    config: {
      toolbar: false,
      statusbar: false,
      showTooltip: false,
      enter: "br",
    },
  },
};

export const phoneVerificationMessengerContentFieldsConfig = {
  textEditor: {
    fieldName: "settings.messenger.template",
    label: "Content",
    infoBoxMsg: `{CODE} - one time password`,
    config: {
      toolbar: false,
      statusbar: false,
      showTooltip: false,
      enter: "br",
    },
  },
};

export const servicesTabsArr = (alias, checkPermission) => {
  switch (alias) {
    case SERVICES.IP_BLOCKER.alias:
      return [
        {
          title: "Statistic",
          icon: <OrderIcon />,
          iconActive: <OrderIconActive />,
          content: <MaliciousIpContainer />,
          disabled: !checkPermission(maliciousIpsAccess.index),
        },
      ];
    case SERVICES.BTAG_MAPPING.alias:
      return [
        {
          title: "Statistic",
          icon: <OrderIcon />,
          iconActive: <OrderIconActive />,
          content: <BtagStatistics />,
          disabled: false,
        },
      ];
  }
};

export const emailContentFieldsConfig = {
  extraTextInput: {
    fieldName: "settings.email.subject",
    label: "Subject",
    placeholder: "Enter email subject",
  },
  textEditor: {
    fieldName: "settings.email.template",
    label: "Content",
    infoBoxMsg: `{CODE} - one time password\n{USERNAME} - username`,
  },
};

export const kycEmailContentFieldsConfig = {
  extraTextInput: {
    fieldName: "settings.email.subject",
    label: "Subject",
    placeholder: "Enter email subject",
  },
  textEditor: {
    fieldName: "settings.email.template",
    label: "Content",
    infoBoxMsg:
      "{PARTYID} - user partyID\n{USERNAME} - username\n{LANGUAGE} - user current locale\n{COUNTRY} - ISO format of user country\n{LINK_DOCUMENTS} - link to user documents section in Core\n{LINK_USER} - link to user profile section in Core",
  },
};

export const collapseIpBlockerConfig = [
  { headTitle: "Login", key: IP_BLOCKER_TYPE.LOGIN },
  { headTitle: "Sign up", key: IP_BLOCKER_TYPE.SIGN_UP },
];

/*
  Notification KYC service works only with english locale.
*/
export const NOTIFICATION_KYC_ENTITY_LIST = ["en"];

export const SCAMMER_MIN_VALUE = 0;
export const SCAMMER_MAX_VALUE = 86400;

export const CHAT_SUPPORT_PROVIDERS = {
  LIVECHAT: "livechat",
  ZENDESK: "zendesk",
  LIVE_AGENT: "liveagent",
  TAWK: "tawk",
  INTERCOM: "intercom",
  RESPOND: "respondio",
};

export const CHAT_SUPPORT_PROVIDER_OPTIONS = [
  {
    label: "Livechat",
    value: CHAT_SUPPORT_PROVIDERS.LIVECHAT,
  },
  {
    label: "Zendesk",
    value: CHAT_SUPPORT_PROVIDERS.ZENDESK,
  },
  {
    label: "Live Agent",
    value: CHAT_SUPPORT_PROVIDERS.LIVE_AGENT,
  },
  {
    label: "Tawk",
    value: CHAT_SUPPORT_PROVIDERS.TAWK,
  },
  {
    label: "Intercom",
    value: CHAT_SUPPORT_PROVIDERS.INTERCOM,
  },
  {
    label: "Respond.io",
    value: CHAT_SUPPORT_PROVIDERS.RESPOND,
  },
];

export const PASSKEYS_DEFAULT_HOST = "stage.auth-passkey.go-aws.dogt.xyz";

export const PASSKEYS_DEFAULT_TOKEN = "token";

export const ZERO_BOUNCE_VALIDATIONS_PER_MINUTE = 1;

export const ZERO_BOUNCE_CACHE_TIME = 1;

export const BTAG_TIMESTAMP_FORMAT = "h:mm A MMM D, YYYY";

export const AUTH_SETTINGS_TYPE = {
  ONE_CLICK: "one_click",
  SOCIAL_NETWORK: "social_network",
  PHONE: "phone",
  WEB3: "web3",
  MOJE_ID: "moje_id",
  M_OBYWATEL: "m_obywatel",
};

export enum SOCIAL_PROVIDER_TYPE {
  FACEBOOK = "facebook",
  GOOGLE = "google",
}

export enum SOCIAL_FIELD_TYPE {
  SIGNUP = "signup",
  SIGNIN = "signin",
  KEY = "key",
  CLIENT_ID = "client_id",
}

export const AUTH_SETTINGS_CONFIG = {
  ONE_CLICK: {
    headTitle: "One Click",
    description: "Enable one click registration on the brand side",
    key: AUTH_SETTINGS_TYPE.ONE_CLICK,
  },
  SOCIAL_NETWORK: {
    headTitle: "Social Network",
    key: AUTH_SETTINGS_TYPE.SOCIAL_NETWORK,
  },
  PHONE: { headTitle: "Phone", key: AUTH_SETTINGS_TYPE.PHONE },
  WEB3: { headTitle: "Web3/crypto Wallets", key: AUTH_SETTINGS_TYPE.WEB3 },
  MOJE_ID: {
    headTitle: "Moje ID",
    description: "Enable registration with Moje ID on the brand side",
    key: AUTH_SETTINGS_TYPE.MOJE_ID,
  },
  M_OBYWATEL: {
    headTitle: "mObywatel",
    description: "Enable registration with mObywatel on the brand side",
    key: AUTH_SETTINGS_TYPE.M_OBYWATEL,
  },
};

export const SERVICE_OPTION_LABELS = {
  sms: "SMS",
  google: "Google",
  email: "Email",
  trusona: "Trusona",

  kyc_aid: "KYC Aid",
  internal: "Internal",

  livechat: "Livechat",
  zendesk: "Zendesk",
  liveagent: "Live Agent",
  tawk: "Tawk",
  intercom: "Intercom",
  respondio: "Respond.io",

  one_click: "One Click",
  social_network: "Social Network",
  phone: "Phone",
  mobywatel: "mObywatel",
  web3: "Web3/crypto Wallets",

  anjouan: "Anjouan",
  curacao: "Curacao",
  em_group: "EM Group",
};

export const CUSTOM_FORM_SERVICES_LIST = ["redeposit"];

export type yupContextLevel1ExtendedType = {
  from: {
    schema: Yup.TestContext["schema"];
    value: {
      [key: string]: object;
    }[];
  };
  options: Yup.TestContext["options"] & {
    index: number;
  };
};

export const LICENCE_TYPE = {
  ANJOUAN: "anjouan",
  CURACAO: "curacao",
  EM_GROUP: "em_group",
};

export const collapseLicenceConfig = [
  { headTitle: "Anjouan", key: LICENCE_TYPE.ANJOUAN },
  { headTitle: "Curacao", key: LICENCE_TYPE.CURACAO },
  { headTitle: "EM Group", key: LICENCE_TYPE.EM_GROUP },
];
